/*eslint-disable */

import Vue from "vue";
import VueResource from "vue-resource";
import Buefy from "buefy";

import { DateTime } from "luxon";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

import router from "./router.js";
import titleMixin from "./mixins/titleMixin";

const APP_ROOT = `${process.env.VUE_APP_ROOT_URL}`;

library.add(fas);

Vue.component("vue-fontawesome", FontAwesomeIcon);
Vue.config.productionTip = false;

Vue.use(VueResource);
Vue.http.options.root = APP_ROOT;

Vue.use(Buefy, {
  defaultIconComponent: "vue-fontawesome",
  defaultIconPack: "fas",
  customIconPacks: {
    fas: {
      sizes: {
        default: "lg",
        "is-small": "1x",
        "is-medium": "2x",
        "is-large": "3x",
      },
      iconPrefix: "",
    },
  },
});

Vue.mixin(titleMixin);

Vue.filter("formatDate", (value) => {
  if (value) {
    const out = DateTime.fromISO(String(value), {zone: 'utc'}).toLocaleString();
    return out;
  }
});

export const createApp = (component) => {
  const app = new Vue({
    router,
    render: (h) => h(component),
  
  })
  return app
}

/*eslint-enable */
